import {FC} from 'react'
import {WithChildren} from '../../helpers'
import {AppLoading} from '../../helpers/components/AppLoading'

const MetronicSplashScreenProvider: FC<WithChildren> = ({children}) => <>{children}</>

const LayoutSplashScreen: FC<{visible?: boolean}> = ({visible = true}) =>
  visible ? (
    <AppLoading
      mode='fullscreen'
      detail='اطلاعات حساب شما با امنیت در حال بارگذاری است'
    />
  ) : null

export {MetronicSplashScreenProvider, LayoutSplashScreen}
